import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loadingInitial, setLoadingInitial] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const listener = onAuthStateChanged(auth, async (authUser) => {
      if(authUser){
        const userDocRef = doc(db, "users", authUser.uid);
        const userDocSnap = await getDoc(userDocRef);
        let userData = {};
        if (userDocSnap.exists()) {
           userData = { ...userDocSnap.data() };
        }
        // Merge authUser and userData
        const mergedUserData = {
          uid: authUser.uid,
          email: authUser.email,
          displayName: authUser.displayName,
          // Merge userData fields with authUser fields
          ...userData,
        };

        //console.log("Merged User Data:", mergedUserData);
        setUser(mergedUserData);
      };
      setLoadingInitial(false)
    }, (error) => {
      console.error("Error in auth state change:", error);
      setLoadingInitial(false);
    });

    return () => listener();
  }, []);

  const memoedValue = useMemo(
    () => ({
      user,
      loadingInitial,
      signOut: () => {
        signOut(auth)
          .then(() => {
            setUser(null);
          })
          .catch((error) => {
            console.error("Sign out error:", error);
          });
      },
    }),
    [
      user,
      loadingInitial
    ]
  );

  return <AuthContext.Provider value={memoedValue}>{!loadingInitial && children}</AuthContext.Provider>;
}

export default function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
